export default __webpack_public_path__ + "static/media/ICONOS INGLÉS  MI SEGURO SOMIT -07.4e1df228.png";